import _slicedToArray from "/home/runner/work/experian-public-site-tng/experian-public-site-tng/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/home/runner/work/experian-public-site-tng/experian-public-site-tng/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/experian-public-site-tng/experian-public-site-tng/node_modules/@babel/runtime/regenerator/index.js";
import { asyncRunOnReadyState, monitorError, Observable } from '@datadog/browser-core';
import { getSessionReplayLink as _getSessionReplayLink } from '../domain/getSessionReplayLink';
import { startRecorderInitTelemetry } from '../domain/startRecorderInitTelemetry';
export function createPostStartStrategy(configuration, lifeCycle, sessionManager, viewHistory, loadRecorder, getOrCreateDeflateEncoder, telemetry) {
  var status = 0 /* RecorderStatus.Stopped */;
  var stopRecording;
  lifeCycle.subscribe(9 /* LifeCycleEventType.SESSION_EXPIRED */, function () {
    if (status === 2 /* RecorderStatus.Starting */ || status === 3 /* RecorderStatus.Started */) {
      stop();
      status = 1 /* RecorderStatus.IntentToStart */;
    }
  });
  lifeCycle.subscribe(10 /* LifeCycleEventType.SESSION_RENEWED */, function () {
    if (status === 1 /* RecorderStatus.IntentToStart */) {
      start();
    }
  });
  var observable = new Observable();
  startRecorderInitTelemetry(telemetry, observable);
  var doStart = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(forced) {
      var _yield$Promise$all, _yield$Promise$all2, startRecordingImpl, deflateEncoder, _startRecordingImpl;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            observable.notify({
              type: 'start',
              forced: forced
            });
            _context.next = 1;
            return Promise.all([notifyWhenSettled(observable, {
              type: 'recorder-settled'
            }, loadRecorder()), notifyWhenSettled(observable, {
              type: 'document-ready'
            }, asyncRunOnReadyState(configuration, 'interactive'))]);
          case 1:
            _yield$Promise$all = _context.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 1);
            startRecordingImpl = _yield$Promise$all2[0];
            if (!(status !== 2 /* RecorderStatus.Starting */)) {
              _context.next = 2;
              break;
            }
            observable.notify({
              type: 'aborted'
            });
            return _context.abrupt("return");
          case 2:
            if (startRecordingImpl) {
              _context.next = 3;
              break;
            }
            status = 0 /* RecorderStatus.Stopped */;
            observable.notify({
              type: 'recorder-load-failed'
            });
            return _context.abrupt("return");
          case 3:
            deflateEncoder = getOrCreateDeflateEncoder();
            if (deflateEncoder) {
              _context.next = 4;
              break;
            }
            status = 0 /* RecorderStatus.Stopped */;
            observable.notify({
              type: 'deflate-encoder-load-failed'
            });
            return _context.abrupt("return");
          case 4:
            ;
            _startRecordingImpl = startRecordingImpl(lifeCycle, configuration, sessionManager, viewHistory, deflateEncoder, telemetry);
            stopRecording = _startRecordingImpl.stop;
            status = 3 /* RecorderStatus.Started */;
            observable.notify({
              type: 'succeeded'
            });
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function doStart(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  function start(options) {
    var session = sessionManager.findTrackedSession();
    if (canStartRecording(session, options)) {
      status = 1 /* RecorderStatus.IntentToStart */;
      return;
    }
    if (isRecordingInProgress(status)) {
      return;
    }
    status = 2 /* RecorderStatus.Starting */;
    var forced = shouldForceReplay(session, options) || false;
    // Intentionally not awaiting doStart() to keep it asynchronous
    doStart(forced)["catch"](monitorError);
    if (forced) {
      sessionManager.setForcedReplay();
    }
  }
  function stop() {
    if (status === 3 /* RecorderStatus.Started */) {
      stopRecording === null || stopRecording === void 0 ? void 0 : stopRecording();
    }
    status = 0 /* RecorderStatus.Stopped */;
  }
  return {
    start: start,
    stop: stop,
    getSessionReplayLink: function getSessionReplayLink() {
      return _getSessionReplayLink(configuration, sessionManager, viewHistory, status !== 0 /* RecorderStatus.Stopped */);
    },
    isRecording: function isRecording() {
      return status === 3;
    } /* RecorderStatus.Started */
  };
}
function canStartRecording(session, options) {
  return !session || session.sessionReplay === 0 /* SessionReplayState.OFF */ && (!options || !options.force);
}
function isRecordingInProgress(status) {
  return status === 2 /* RecorderStatus.Starting */ || status === 3 /* RecorderStatus.Started */;
}
function shouldForceReplay(session, options) {
  return options && options.force && session.sessionReplay === 0 /* SessionReplayState.OFF */;
}
function notifyWhenSettled(_x2, _x3, _x4) {
  return _notifyWhenSettled.apply(this, arguments);
}
function _notifyWhenSettled() {
  _notifyWhenSettled = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(observable, event, promise) {
    return _regeneratorRuntime.wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 1;
          return promise;
        case 1:
          return _context2.abrupt("return", _context2.sent);
        case 2:
          _context2.prev = 2;
          observable.notify(event);
          return _context2.finish(2);
        case 3:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0,, 2, 3]]);
  }));
  return _notifyWhenSettled.apply(this, arguments);
}